<template>
  <div>
    <ul class="presentation">
      <router-link :to="'/days/' + $route.params.day + '/' + session.id">
        <li>
          <table>
            <tbody>
            <tr>
              <td>Sess. time</td>
              <td>{{ session.start_time }} &ndash; {{ session.end_time }}</td>
            </tr>
            <tr>
              <td>Sess. room</td>
              <td>{{ session.room.name }}</td>
            </tr>
            <tr v-if="session.session_group">
              <td>Sess. group</td>
              <td>{{ session.session_group.name }}</td>
            </tr>
            <tr class="type" v-if="session.session_type">
              <td>Sess. type</td>
              <td>
                  <span class="type"
                        :style="{ color: session.session_type.value.color, background: session.session_type.value.background }">
                    {{ session.session_type.name }}
                  </span>
              </td>
            </tr>
            <tr class="title">
              <td>Sess. title</td>
              <td>
                <b>{{ session.code }} {{ session.title }}</b>
              </td>
            </tr>
            <tr class="title" v-if="session.content.comment">
              <td>Comment</td>
              <td>
                <b style="color:red">{{ session.content.comment }} </b>
              </td>
            </tr>
            <tr class="title">
              <td>Q&A Inbox</td>
              <td>
                <a :href="session.qanda_link" target="_blank"><b>Click here to see the questions from the audience </b></a>
              </td>
            </tr>
            <tr class="persons" v-if="session.persons.length">
              <td></td>
              <td>
                <ul v-if="session.persons.length">
                  <li v-for="(pval, pkey) in session.persons" :key="pkey">
                    {{ pval.role.name }}:
                    {{ pval.person.title }}
                    {{ pval.person.first_name }}
                    {{ pval.person.last_name }}
                    <span v-if="pval.person.city || pval.person.country">
                        <span>(</span>
                        <span v-if="pval.person.city">{{ pval.person.city }}</span>
                        <span v-if="pval.person.city && pval.person.country">, </span>
                        <span v-if="pval.person.country">{{ pval.person.country.wording.value }}</span>
                        <span>)</span>
                      </span>
                  </li>
                </ul>
              </td>
            </tr>

            <tr>
              <td>Director Comment</td>
              <td>{{session.director_comment}}</td>
            </tr>
            </tbody>
          </table>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-left']"/>
          </span>
        </li>
      </router-link>
      <li class="current">
        <table>
          <tbody>
          <tr>
            <td>Pres. ID</td>
            <td>{{ presentation.id }}</td>
          </tr>
          <tr>
            <td>Pres. time</td>
            <td>{{ presentation.start_time }} &ndash; {{ presentation.end_time }}</td>
          </tr>
          <tr>
            <td>Pres. title</td>
            <td><b>{{ presentation.code }} {{ presentation.title }}</b></td>
          </tr>
          <tr v-if="presentation.content && presentation.content.notes">
            <td>Pres. Notes</td>
            <td><b style="color:red">{{ presentation.content.notes }}</b></td>
          </tr>
          <tr v-if="presentation.content && presentation.content.comment">
            <td>Pres. comment</td>
            <td><b style="color:red">{{ presentation.content.comment }}</b></td>
          </tr>
          <tr v-if="presentation.content && presentation.content.comment_sound">
            <td>Sound source</td>
            <td><b style="color:red">{{ presentation.content.comment_sound }}</b></td>
          </tr>
          <tr v-if="presentation.content && presentation.content.comment_video">
            <td>Camera notice</td>
            <td><b style="color:red">{{ presentation.content.comment_video }}</b></td>
          </tr>
          <tr v-if="presentation.content && presentation.content.comment_location">
            <td>External / Studio</td>
            <td><b style="color:red">{{ presentation.content.comment_location }}</b></td>
          </tr>
          <tr v-if="presentation.director_comment">
            <td>Director Comment</td>
            <td><b style="color:red">{{ presentation.director_comment }}</b></td>
          </tr>
          </tbody>
        </table>
        <br>

      </li>
      <li>
        <form class="form-inline">
          <label class="my-1 mr-2" for="inlineFormInputName2">Regie Comment</label>
          <input type="text" class="form-control my-1 mr-sm-2" style="width:500px" id="inlineFormInputName2" placeholder="Comment" v-model="presentation.director_comment">

          <button type="submit" class="btn btn-primary my-1 mr-sm-2" @click.prevent="saveComment()"> Save Comment</button>
        </form>
      </li>
      <li>
        <video-upload :target="presentation" :type="'presentation'"></video-upload>
      </li>
    </ul>
    <ul class="persons">
      <router-link v-for="(pval, pkey) in presentation.persons" :key="pkey"
                   :to="'/days/' + $route.params.day + '/' + $route.params.session + '/' + $route.params.presentation + '/' + pval.id">
        <li>
          <table>
            <tbody>
            <tr>
              <td>&nbsp;</td>
              <td>
                {{ pval.role.name }}:
                {{ pval.person.title }}
                {{ pval.person.first_name }}
                {{ pval.person.last_name }}
                <span v-if="pval.person.city || pval.person.country">
                    <span>(</span>
                    <span v-if="pval.person.city">{{ pval.person.city }}</span>
                    <span v-if="pval.person.city && pval.person.country">, </span>
                    <span v-if="pval.person.country">{{ pval.person.country.wording.value }}</span>
                    <span>)</span>
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-right']"/>
          </span>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import VideoUpload from './VideoUpload';

export default {
  components: {
    'video-upload': VideoUpload,
  },
  data() {
    return {
      session: null,
      presentation: null,
    }
  },
  computed: {
    ...mapState(['sessions', 'presentations']),
  },
  methods: {
    ...mapActions(['setComment']),
    getSession() {
      this.session = this.sessions.find(session => session.id == this.$route.params.session);
      let appid_prefix = 'da7ad0c0-3ed1-4500-1308-0'
      let appid_base = 10000000000;
      let final_id = appid_base + parseInt(this.session.id);
      let qanda_link = 'https://interactive.documedias.com/#/1308/sessions/' + appid_prefix + final_id + '/questions'
      this.session.qanda_link = qanda_link;
    },
    getPresentation() {
      this.presentation = this.presentations.find(presentation => presentation.id == this.$route.params.presentation);
    },
    saveComment(){
      this.setComment({id: this.$route.params.presentation, type:'presentations',comment: this.presentation.director_comment});
    }
  },
  created() {
    this.getSession();
    this.getPresentation();
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/colors';

.presentation {
  padding: 0;
  margin: 0;

  > a > li, > li {
    list-style: none;
    padding: 13px 16px 12px 16px;
    border-bottom: 1px solid #e4e4e4;
    position: relative;

    &.current {
      background: #f4f4f4;
    }

    > table {
      border: 0;
      border-spacing: 0;
      border-collapse: collapse;

      > tbody {
        > tr {
          > td {
            padding: 2px 0;

            &:first-child {
              width: 150px;
            }

            > .type {
              display: inline-block;
              margin-left: -2px;
              padding: 3px 2px 2px 2px;
              border-radius: 3px;
            }
          }

          &.type > td {
            padding: 0;
          }

          &.title > td {
            padding-top: 10px;
          }

          &.persons > td {
            padding-top: 10px;

            > ul {
              padding: 0;

              > li {
                list-style: none;
              }
            }
          }
        }
      }
    }

    > .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-13px);
      right: 16px;
      display: inline-block;
      height: 100%;
      font-size: 24px;
      opacity: .3;
    }

    > .persons {
      padding: 0;
      margin: 8px 0 0 0;

      > li {
        list-style: none;
      }
    }
  }

  > a:hover > li {
    background: lighten($conference-color, 95%);

    .arrow {
      opacity: 1;
    }
  }
}

.persons {
  padding: 0;
  margin: 0;

  > a > li {
    list-style: none;
    padding: 13px 16px 12px 16px;
    border-bottom: 1px solid #e4e4e4;
    position: relative;

    > table {
      border: 0;
      border-spacing: 0;
      border-collapse: collapse;

      > tbody {
        > tr {
          > td {
            padding: 2px 0;

            &:first-child {
              width: 150px;
            }

            > .type {
              display: inline-block;
              margin-left: -2px;
              padding: 3px 2px 2px 2px;
              border-radius: 3px;
            }
          }

          &.type > td {
            padding: 0;
          }

          &.title > td {
            padding-top: 10px;
          }

          &.persons > td {
            padding-top: 10px;

            > ul {
              padding: 0;

              > li {
                list-style: none;
              }
            }
          }
        }
      }
    }

    > .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-13px);
      right: 16px;
      display: inline-block;
      height: 100%;
      font-size: 24px;
      opacity: .3;
    }
  }

  > a:hover {
    text-decoration: none;

    > li {
      background: lighten($conference-color, 95%);

      .arrow {
        opacity: 1;
      }
    }
  }
}
</style>